module.exports = {
          srcSet: __webpack_public_path__ + "public/images/24576d932d2b0306e034ed5ca39ac00d-1774.jpg"+" 1774w",
          images:[ {path: __webpack_public_path__ + "public/images/24576d932d2b0306e034ed5ca39ac00d-1774.jpg",width: 1774,height: 887}],
          src: __webpack_public_path__ + "public/images/24576d932d2b0306e034ed5ca39ac00d-1774.jpg",
          toString:function(){return __webpack_public_path__ + "public/images/24576d932d2b0306e034ed5ca39ac00d-1774.jpg"},
          
          width: 1774,
          height: 887
        }